var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9557 6.18391L4.98066 22.4889C4.45566 22.9389 4.77066 23.8089 5.47566 23.8089H43.4257C44.1157 23.8089 44.4457 22.9389 43.9207 22.4889L24.9457 6.18391C24.6607 5.94391 24.2557 5.94391 23.9707 6.18391H23.9557Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.453 23.9437L24.123 10.8037L8.79297 23.9437V41.6737C8.79297 42.0937 9.12297 42.4237 9.54297 42.4237H38.748C39.168 42.4237 39.498 42.0937 39.498 41.6737V23.9437H39.438H39.453Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6787 29.5245C26.8658 29.5245 28.6388 27.7515 28.6388 25.5645C28.6388 23.3774 26.8658 21.6045 24.6787 21.6045C22.4917 21.6045 20.7188 23.3774 20.7188 25.5645C20.7188 27.7515 22.4917 29.5245 24.6787 29.5245Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5163 37.3552C30.9213 37.3552 31.2513 37.0102 31.2063 36.6202C30.8463 33.3352 28.0563 30.7852 24.6813 30.7852C21.3063 30.7852 18.5163 33.3352 18.1563 36.6202C18.1113 37.0102 18.4563 37.3552 18.8463 37.3552H30.5163Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.e5190fa9a549a4dbafece638e0495d16.svg";
export { ForwardRef as ReactComponent };